import { VIEW_SECTION_REQUEST, VIEW_SECTION_SUCCESS, VIEW_SECTION_ERROR, RESET_VIEW_SECTION } from "../actions/viewSection"

let initialState = {
    loading: false,
    data: null,
    error: null
}

const viewSection = (state = initialState, action) => {
    switch (action.type) {
        case VIEW_SECTION_REQUEST:
            return {
                ...state,
                loading: true
            }

        case VIEW_SECTION_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case VIEW_SECTION_ERROR:
            return {
                ...state,
                loading: false,
                data: action.payload
            }
        case RESET_VIEW_SECTION:
            return {
                ...state,
                loading: false,
                data: null,
                error: null
            }
        default:
            return state;
    }
}

export default viewSection